import { AxiosError } from "axios";
import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import adminAxios from "@/lib/axios";

export interface IBannerVideo {
  id?: number | string;
  page_id?: number;
  component_id?: number;
  desktop_background_color?: string;
  mobile_background_color?: string;
  backvariant?: string;
  gradient_color_1?: string;
  gradient_color_2?: string;
  gradient_color_3?: string;
  gradient_color_4?: string;
  slide_frequency?: number;
  variant?: string;
  metadata?: Array<{
    id?: number | string;
    meta_desktop_image?: string;
    meta_mobile_image?: string;
    meta_alt_image?: string;
    meta_priority?: number;
    meta_status?: boolean;
    meta_click_action?: "lead_drop" | "video";
    meta_video_link?: string;
    meta_redirect_url?: string;
  }>;
  status?: boolean;
}

export async function createBannerVideo(payload: Partial<IBannerVideo>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.BANNER_VIDEO.CREATE,
      payload
    );
    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateBannerVideo(id: number, payload: Partial<IBannerVideo>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.BANNER_VIDEO.UPDATE(id),
      payload
    );
    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}
